module.exports = __webpack_public_path__ + "static/media/header-img.990ab8a4.png";